<template>
  <div class="card" >
    <div class="card-body">
      <div class="change-product-seller">
        <h5 class="mb-0">RESELLER</h5>
         
        <p v-if="product_detail.reseller">
          <strong>{{product_detail.reseller.company ? product_detail.reseller.company : ''}}</strong> <br/>
          <span v-if="product_detail.reseller.mobile">{{product_detail.reseller.mobile}} <br/></span>
          <span v-if="product_detail.reseller.email">{{product_detail.reseller.email}} <br/></span>
        </p>
         <vue-autosuggest
            :suggestions="resellerSuggestions"
            :input-props="{class:'form-control', id:'autosuggest_reseller_input', placeholder:'Change Reseller'}"
            @input="onChangeResellerInput"
            @selected="selectResellerHandler"
            @click="onChangeResellerInput"
            :getSuggestionValue="resellerSuggestionsValue"
          >  
          <template slot-scope="{suggestion}">
            <span class="my-suggestion-item" v-html="suggestion.item.company ? suggestion.item.company: suggestion.item.email"></span>
          </template>
        </vue-autosuggest>
        <p class="mt-2 mb-0"> <em>Cant find? <router-link :to="{ name: 'SuperadminCustomersAdd', query: { redirect: 'SuperadminRegisteredProductEdit', id: $route.params.id }}">Add reseller</router-link></em></p>
        <button class="btn btn-primary rounded mt-3" @click.prevent="updateReseller()">Update</button> 
      </div>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  components: {
    VueAutosuggest
  },
  props: ['product_detail'],
  data() {
    return {

      resellerSuggestions: [
        {
          data:[]
        }
      ],

    }
  },
  methods:{


    onChangeResellerInput: _.debounce(function(name){

      if(name == null) {
        name = document.getElementById('autosuggest_reseller_input').value;
      }

      const url = `${Env.baseUrl}/superadmin/users/suggest-user?type=reseller`;
      AuthApis.postApi(url, {
        name: name
      }).then(res => {
        this.resellerSuggestions[0].data = res.data.payload;
      }).catch(err => {
        console.log(err)
      })

    }, 800),


    selectResellerHandler(obj) {
      this.product_detail.reseller_id = obj.item.id;
      this.product_detail.reseller = obj.item;
      this.resellerSuggestions[0].data = [];
    },

    resellerSuggestionsValue(obj) {
       return (obj.item.company ? obj.item.company : obj.item.fname );
    },
    
    updateReseller() {
       const url = `${Env.baseUrl}/superadmin/users/update-user/${this.product_detail.id}`;
      AuthApis.postApi(url, {
        type: 'reseller',
        user_id: this.product_detail.reseller_id,
      }).then(res => {
        this.$toasted.global.success({
          message: res.data.message,
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
</script>